module.exports = __webpack_public_path__ + "static/media/cert_part3_gemini.7e586632.png";